import { Badge } from '@/shared/components/ui/badge';
import { cn } from '@/shared/lib/utils';
import { sanitizeTagColor } from '../utils/virtual-categories';
import type { CategoryTag as CategoryTagType } from '../types/get-store-items';

interface CategoryTagProps {
  tag: CategoryTagType;
  className?: string;
}

/**
 * Etiqueta exibida ao lado do título das categorias virtuais do cardápio
 * (ex.: "Mais pedidos", "Novidades"). Quando o backend fornece uma cor hex
 * válida ela é usada como destaque; caso contrário, cai no estilo padrão.
 *
 * O rótulo é renderizado como texto puro (React escapa o conteúdo), e a cor
 * passa por saneamento antes de ir para o `style` inline, evitando injeção
 * de CSS a partir de dados controlados pelo backend.
 */
export function CategoryTag({ tag, className }: CategoryTagProps) {
  const label = tag.label.trim();
  if (!label) return null;

  const color = sanitizeTagColor(tag.color);

  return (
    <Badge
      variant={color ? 'outline' : 'secondary'}
      className={cn('text-[10px] uppercase tracking-wide', className)}
      style={color ? { color, borderColor: color } : undefined}
    >
      {label}
    </Badge>
  );
}
